import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import SysDigMappingForm from './SysDigMappingForm';
import { urlRegexValidator } from 'utils/formUtils';

function SysDigCredentialsForm(props, ref) {
    const fields = useMemo(() => [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules: [urlRegexValidator()]
    }, {
        name: "token",
        label: "API Token",
        type: FieldTypes.PASSWORD,
        required: true
    }],[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            versionField={false}
            MappingForm={SysDigMappingForm}
        />
    )
}

export default forwardRef(SysDigCredentialsForm);